import React from 'react'
import PropTypes from 'prop-types'
import { color } from '@ticketswap/solar'
import NProgress from 'nprogress'
import Router from 'next/router'
import { Global, css } from '@emotion/core'

let timeout

const start = () => {
  timeout = setTimeout(NProgress.start, 100)
}

const done = () => {
  clearTimeout(timeout)
  NProgress.done()
}

NProgress.configure({ showSpinner: false })
Router.events.on('routeChangeStart', start)
Router.events.on('routeChangeComplete', done)
Router.events.on('routeChangeError', done)

const ProgressBar = ({ variant }) => (
  <Global
    styles={css`
      /* Make clicks pass-through */
      #nprogress {
        pointer-events: none;
      }

      #nprogress .bar {
        background: ${variant};
        position: fixed;
        z-index: 1031;
        top: 0;
        left: 0;
        width: 100%;
        height: 3px;
      }

      /* Fancy blur effect */
      #nprogress .peg {
        display: block;
        position: absolute;
        right: 0px;
        width: 100px;
        height: 100%;
        box-shadow: 0 0 10px ${variant}, 0 0 5px ${variant};
        opacity: 1;
        transform: rotate(3deg) translate(0px, -4px);
      }
    `}
  />
)

ProgressBar.defaultProps = {
  variant: color.earth,
}

ProgressBar.propTypes = {
  variant: PropTypes.string,
}

export default ProgressBar
